const CHOOSE_SIZE_LABEL = 'Choose a size to add to bag';

let userChoseSize = false;
let shopperInteracted = false;
let guideBound = false;

function inventoryList() {
  const node = document.querySelector('[data-pdp-inventory]');
  if (!node) return [];
  try {
    const parsed = JSON.parse(node.textContent || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function checkedSize() {
  return document.querySelector('.product-information variant-picker input[type="radio"]:checked');
}

function setButtonLabel(button, label) {
  if (!button) return;
  const content = button.querySelector('.add-to-cart-text__content span span, .add-to-cart-text__content');
  if (content) content.textContent = label;
  else button.textContent = label;
}

function clearVariantParam() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('variant')) return;
  url.searchParams.delete('variant');
  history.replaceState({}, '', url.toString());
}

function applyAwaitingSize() {
  if (userChoseSize) return;
  const picker = document.querySelector('.product-information variant-picker');
  const radios = picker ? [...picker.querySelectorAll('input[type="radio"]')] : [];
  if (!radios.length) return;

  document.body.classList.add('pdp-awaiting-size');
  document.body.classList.remove('pdp-size-chosen');
  radios.forEach((radio) => {
    radio.checked = false;
    radio.removeAttribute('checked');
    radio.dataset.currentChecked = 'false';
    radio.dataset.previousChecked = 'false';
  });
  const button = document.querySelector('product-form-component [name="add"]');
  if (button) {
    button.disabled = true;
    setButtonLabel(button, CHOOSE_SIZE_LABEL);
  }

  const variantInput = document.querySelector('product-form-component input[name="id"]');
  if (variantInput) variantInput.disabled = true;

  const stickyButton = document.querySelector('.sticky-add-to-cart__button');
  if (stickyButton) {
    stickyButton.setAttribute('disabled', 'disabled');
    setButtonLabel(stickyButton, CHOOSE_SIZE_LABEL);
  }

  const sheetButton = document.querySelector('.pdp-mobile-sheet__cta');
  if (sheetButton) sheetButton.textContent = CHOOSE_SIZE_LABEL;
}

function lowStockMax(line) {
  const value = Number(line.dataset.lowStockMax);
  return Number.isFinite(value) && value > 0 ? value : 10;
}

function updateLowStock() {
  const line = document.querySelector('[data-low-stock]');
  if (!line) return;
  const selected = checkedSize();
  const variantId = selected && selected.dataset.variantId;
  const match = inventoryList().find((item) => String(item.id) === String(variantId));
  const max = lowStockMax(line);
  const show = Boolean(match && match.managed && match.qty > 0 && match.qty <= max && !document.body.classList.contains('pdp-awaiting-size'));

  if (!show) {
    line.hidden = true;
    line.textContent = '';
    return;
  }

  const size = match.title === 'Default Title' ? '' : match.title;
  line.hidden = false;
  line.textContent = size ? `Only ${match.qty} left in size ${size}` : `Only ${match.qty} left`;
}

function sizeLegend() {
  const legends = [...document.querySelectorAll('.product-information variant-picker fieldset legend')];
  return legends.find((legend) => /size/i.test(legend.textContent || '')) || legends.at(-1) || null;
}

function placeSizeGuide() {
  const source = document.querySelector('[data-size-guide-source]');
  const legend = sizeLegend();
  if (!source || !legend || legend.querySelector('[data-size-guide-open]')) return;
  const button = source.cloneNode(true);
  button.hidden = false;
  button.removeAttribute('hidden');
  button.removeAttribute('data-size-guide-source');
  legend.appendChild(button);
}

function placeLowStock() {
  const line = document.querySelector('[data-low-stock]');
  const picker = document.querySelector('.product-information variant-picker');
  if (!line || !picker) return;
  if (line.previousElementSibling === picker) return;
  picker.after(line);
}

function bindSizeGuide() {
  if (guideBound) return;
  guideBound = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const dialog = document.querySelector('[data-size-guide]');
    if (!dialog) return;
    if (target.closest('[data-size-guide-open]')) {
      if (typeof dialog.showModal === 'function') dialog.showModal();
    }
    if (target.closest('[data-size-guide-close]')) dialog.close();
  });
}

function refreshBuyBox() {
  placeSizeGuide();
  placeLowStock();
  if (userChoseSize) document.body.classList.remove('pdp-awaiting-size');
  else applyAwaitingSize();
  updateLowStock();
}

function initPdpBuyBox() {
  bindSizeGuide();
  applyAwaitingSize();
  refreshBuyBox();
}

function markShopperInteraction() {
  shopperInteracted = true;
}

document.addEventListener('pointerdown', markShopperInteraction, true);
document.addEventListener('keydown', markShopperInteraction, true);

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLInputElement)) return;
  if (!target.closest('.product-information variant-picker')) return;
  if (!shopperInteracted) {
    applyAwaitingSize();
    return;
  }
  userChoseSize = true;
  window.__pdpSizeChosen = true;
  document.body.classList.add('pdp-size-chosen');
  document.body.classList.remove('pdp-awaiting-size');
  const variantInput = document.querySelector('product-form-component input[name="id"]');
  if (variantInput) variantInput.disabled = false;
});

function restoreUnselectedSize(event) {
  if (!event.persisted) return;
  userChoseSize = false;
  shopperInteracted = false;
  window.__pdpSizeChosen = false;
  applyAwaitingSize();
}

initPdpBuyBox();
window.addEventListener('pagehide', () => {
  document.body.classList.remove('pdp-size-chosen');
});
window.addEventListener('pageshow', restoreUnselectedSize);
window.setTimeout(() => {
  if (!userChoseSize) clearVariantParam();
}, 700);
document.addEventListener('variant:update', () => {
  window.setTimeout(() => {
    if (!userChoseSize) {
      applyAwaitingSize();
      return;
    }
    refreshBuyBox();
    const sheetButton = document.querySelector('.pdp-mobile-sheet__cta');
    const mainButton = document.querySelector('product-form-component [name="add"]');
    const label = mainButton && mainButton.querySelector('.add-to-cart-text__content');
    if (sheetButton && label) sheetButton.textContent = label.textContent.replace(/\s+/g, ' ').trim();
  }, 50);
});
document.addEventListener('shopify:section:load', refreshBuyBox);
